export const floatlabel = {
  root: {
    class: [
      'group/float-label min-w-0',
      '[&>*:last-child]:max-w-[calc(100%-1.75rem)]',
      '[&>*:last-child]:truncate',
      '[&>*:last-child]:after:absolute',
      '[&>*:last-child]:after:inset-[50%_0_0_0]',
      '[&>*:last-child]:after:-z-10',
      // Niet alle prime vue componenten hebben een echt input component
      // Daarom hier ook op basis van role zoeken
      '[&>*:last-child]:has-[[role=combobox],input,textarea]:after:bg-white',
      'grow',
      'flex relative',

      // Base Label Appearance
      '[&>*:last-child]:text-grey-400',
      '[&>*:last-child]:absolute',
      '[&>*:last-child]:top-1/2',
      '[&>*:last-child]:-translate-y-1/2',
      '[&>*:last-child]:has-[[role=combobox],input,textarea]:left-3',
      '[&>*:last-child]:pointer-events-none',
      '[&>*:last-child]:transition-all',
      '[&>*:last-child]:duration-200',
      '[&>*:last-child]:ease',
      '[&:not(:has(.filled,:focus,:placeholder-shown))>*:last-child]:has-[.text-xs]:text-xs',
      '[&:not(:has(.filled,:focus,:placeholder-shown))>*:last-child]:has-[.text-xl]:text-xl',

      // Focus Label Appearance
      '[&>*:last-child]:has-[:focus]:-top-0.5',
      '[&>*:last-child]:has-[:focus]:left-3.5',
      '[&>*:last-child]:has-[:focus]:px-[.1875rem]',
      '[&>*:last-child]:has-[:focus]:text-xs',
      '[&>*:last-child]:has-[:focus]:text-grey-600',

      // Filled Input Label Appearance
      '[&>*:last-child]:has-[.filled]:-top-0.5',
      '[&>*:last-child]:has-[[role=combobox],input,textarea]:left-3.5',
      '[&>*:last-child]:has-[[role=combobox],input,textarea]:px-[.1875rem]',
      '[&>*:last-child]:has-[.filled]:text-xs',
      '[&>*:last-child]:has-[.filled]:text-grey-600',

      // Placeholder Label Appearance
      '[&>*:last-child]:has-[:placeholder-shown]:-top-0.5',
      '[&>*:last-child]:has-[:placeholder-shown]:left-3.5',
      '[&>*:last-child]:has-[:placeholder-shown]:px-[.1875rem]',
      '[&>*:last-child]:has-[:placeholder-shown]:text-xs',
      '[&>*:last-child]:has-[:placeholder-shown]:text-grey-600',

      // Disabled Label Appearance
      '[&>*:last-child]:has-[[role=combobox],input,textarea]:has-[:disabled,[aria-disabled="true"]]:after:bg-grey-50',
    ],
  },
};
